import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  SelectChangeEvent,
  Box,
} from "@mui/material";

interface CustomGridFooterProps {
  count: number;
  pageSize: number;
  page: number; // zero-based page index
  rowsPerPageOptions: number[];
  onPageSizeChange: (size: number) => void;
  onPageChange: (event: React.SyntheticEvent, page: number) => void; // page is zero-based
  className?: string;
  style?: React.CSSProperties;
}

const CustomGridFooter: React.FC<CustomGridFooterProps> = ({
  count,
  pageSize,
  page,
  rowsPerPageOptions,
  onPageSizeChange,
  onPageChange,
  className,
  style,
}) => {
  const totalPages = Math.max(1, Math.ceil(count / pageSize));

  const handlePageSizeChange = (event: SelectChangeEvent<string | number>) => {
    const value = Number(event.target.value);
    onPageSizeChange(value);
  };

  const handlePaginationChange = (
    _: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    // MUI Pagination is 1-based; convert to zero-based for parent
    onPageChange(_ as React.SyntheticEvent, newPage - 1);
  };

  return (
    <Box
      className={className}
      style={style}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px",
      }}
    >
      <div className="flex gap-5 items-center text-[#04438b]">
        <FormControl size="small" variant="outlined">
          <InputLabel id="rows-per-page-label">Редови</InputLabel>
          <Select
            labelId="rows-per-page-label"
            value={pageSize}
            label="Редови"
            sx={{ minWidth: 70 }}
            onChange={handlePageSizeChange}
            inputProps={{
              name: "rows-per-page",
              id: "rows-per-page",
            }}
          >
            {rowsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <p>Укупно слогова: {count}</p>
      </div>

      <Pagination
        shape="rounded"
        count={totalPages}
        page={page + 1} // convert zero-based page to MUI's 1-based page
        onChange={handlePaginationChange}
        siblingCount={1}
        boundaryCount={1}
      />
    </Box>
  );
};

export default React.memo(CustomGridFooter);
